export default function CAEditBankLogoDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  orgDataService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleBankLogoFileAdd = _handleBankLogoFileAdd;
  vm.handleEditBankLogoFormSubmit = _handleEditBankLogoFormSubmit;

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bankLogoEditDialog);
  }

  function _handleCloseDialogClick() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleBankLogoFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.logo.file.progress = 0;
  }

  function _handleEditBankLogoFormSubmit() {
    orgDataService.saveCustomerLogo(vm.customerId, vm.logo.file).then((res) => {
      if (res.data.documentId > 0) {
        alerts.success('The Bank Logo has been saved successfully.');
        $rootScope.$broadcast('refreshCustomer', {
          customerId: vm.customerId
        });
      } else {
        alerts.error('Error occurred saving Bank Logo.');
      }
      _closeDialog();
    });
  }
}


CAEditBankLogoDialogController.$inject = [
  '$rootScope',
  '$q',

  'alerts',
  'ssDialogService',
  'orgDataService'
];
